import ImageBanner from "../../components/ImageBanner";
import React, { useContext, useEffect, useState } from "react";
import {
  Modal,
  Form,
  SelectPicker,
  Button,
  Radio,
  RadioGroup,
  InputNumber,
  DatePicker,
  Input,
  Checkbox,
  Loader,
  Dropdown,
} from "rsuite";
import toast from "react-hot-toast";
import bgImage from "../../assets/images/suppliersLogo/01.jpg";
/* hook */
import { useCities } from "../../hooks/useQuery/useRegions";
/* validation */
import { inquireValidation, newBookNowValidation } from "../../validations";
/* api */
import apiRoutes from "../../api/apiRoutes";
import ApiCall from "../../api/network";
// todo
import { TripContext } from "../../context";
// import { getDate } from "../../../../utils/dateFormatter";
// import { ShowPrice, showToast, getDate } from ".";
import { BS } from "../../common/Icons";

let initialValues = {
  description: "",
  home_departure_city: "",
  preferred_departure_date: null,
  trip_duration: "",
  preferred_destination: "",
  number_of_passengers: null,
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
};

const Inquire = () => {
  //todo
  const { bookingData, setBookingData } = useContext(TripContext);

  const [formValue, setFormValues] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [radio, setRadio] = useState("no");
  const [errors, setErrors] = useState({});

  const { isLoading, data: cities } = useCities();

  const onChange = (value, name) => {
    setFormValues({ ...formValue, [name]: value });
    if (Object.keys(errors).length > 0) {
      if (errors.hasOwnProperty(name)) delete errors[name];
    }
  };

  const onSubmit = async () => {
    let validations = inquireValidation(formValue);
    if (Object.keys(validations).length > 0) {
      console.log(validations, "validation");
      setErrors(validations);
      return;
    }
    setLoading(true);
    const formData = new FormData();

    formData.append("description", formValue?.description);
    formData.append("home_departure_city", formValue?.home_departure_city);
    formData.append(
      "preferred_departure_date",
      formValue?.preferred_departure_date
    );
    formData.append("number_of_passengers", formValue?.number_of_passengers);
    formData.append("trip_duration", formValue?.trip_duration);
    formData.append("first_name", formValue?.first_name);
    formData.append("last_name", formValue?.last_name);
    formData.append("email", formValue?.email);
    formData.append("phone", formValue?.phone);
    formData.append("preferred_destination", formValue?.preferred_destination);
    const response = await ApiCall.any(apiRoutes.inquiries, {}, formData);
    if (response?.status === 1) {
      setFormValues(initialValues);

      toast.success("Submitted!", {
        duration: 2500,
      });
    }
    setLoading(false);
  };
  return (
    <div>
      <div className="last-minute-deals">
        <ImageBanner image={bgImage} title={"INQUIRE"} />
        <div className="lead-generation-form container containerd w-75 p-4 my-4">
          <Form className="row" onSubmit={onSubmit}>
            {/* destination */}
            <Form.Group className="col-md-6">
              <Input
                placeholder="Home Departure City"
                onChange={(e) => onChange(e, "home_departure_city")}
                value={formValue?.home_departure_city}
              />
              {errors?.home_departure_city && (
                <Form.ErrorMessage show={errors?.home_departure_city}>
                  {errors?.home_departure_city}
                </Form.ErrorMessage>
              )}
            </Form.Group>

            <Form.Group className="col-md-6">
              {/* <label style={{ fontSize: 14 }}>Date of Birth</label> */}
              <DatePicker
                oneTap
                block
                value={formValue?.preferred_departure_date}
                format="yyyy/MM/dd"
                placeholder="yyyy/mm/dd"
                label={"Preferred Departure Date"}
                // value={data?.date_of_birth ? data?.date_of_birth : undefined}
                onChange={(e) => onChange(e, "preferred_departure_date")}
              />

              {errors?.preferred_departure_date && (
                <Form.ErrorMessage show={errors?.preferred_departure_date}>
                  {errors?.preferred_departure_date}
                </Form.ErrorMessage>
              )}
            </Form.Group>

            <Form.Group className="col-md-6">
              <InputNumber
                min={1}
                max={100}
                value={formValue?.trip_duration}
                placeholder="Trip Duration (Days)"
                onChange={(e) => onChange(e, "trip_duration")}
              />
              {errors?.trip_duration && (
                <Form.ErrorMessage show={errors?.trip_duration}>
                  {errors?.trip_duration}
                </Form.ErrorMessage>
              )}
            </Form.Group>
            <Form.Group className="col-md-6">
              <Input
                value={formValue?.preferred_destination}
                placeholder="Preferred Destination(s)"
                onChange={(e) => onChange(e, "preferred_destination")}
              />
              {errors?.preferred_destination && (
                <Form.ErrorMessage show={errors?.preferred_destination}>
                  {errors?.preferred_destination}
                </Form.ErrorMessage>
              )}
            </Form.Group>
            {/* passengers */}
            <Form.Group className="col-md-6">
              <InputNumber
                min={1}
                value={formValue?.number_of_passengers}
                max={100}
                placeholder="Passenger Number"
                onChange={(e) => onChange(e, "number_of_passengers")}
              />
              {errors?.number_of_passengers && (
                <Form.ErrorMessage show={errors?.number_of_passengers}>
                  {errors?.number_of_passengers}
                </Form.ErrorMessage>
              )}
              {/* radio */}
              {/* {formValue?.passengerNumber == 1 ? (
                <div className="px-1">
                  <RadioGroup
                    name="radioList"
                    inline
                    className="d-flex justify-content-between align-items-center"
                  >
                    if single, are you looking for a travel companion
                    <Radio
                      value="yes"
                      defaultChecked={radio === "yes"}
                      onChange={() => setRadio("yes")}
                    >
                      yes
                    </Radio>
                    <Radio
                      value="no"
                      defaultChecked={radio === "no"}
                      onChange={() => setRadio("no")}
                    >
                      no
                    </Radio>
                  </RadioGroup>
                </div>
              ) : null} */}
            </Form.Group>

            {/* Contact */}
            <Form.Group className="col-md-6">
              <Input
                value={formValue?.phone}
                placeholder="Phone "
                onChange={(e) => onChange(e, "phone")}
              />
              {errors?.phone && (
                <Form.ErrorMessage show={errors?.phone}>
                  {errors?.phone}
                </Form.ErrorMessage>
              )}
            </Form.Group>
            <Form.Group className="col-md-6">
              <Input
                value={formValue?.first_name}
                placeholder="First Name "
                onChange={(e) => onChange(e, "first_name")}
              />
              {errors?.first_name && (
                <Form.ErrorMessage show={errors?.first_name}>
                  {errors?.first_name}
                </Form.ErrorMessage>
              )}
            </Form.Group>
            <Form.Group className="col-md-6">
              <Input
                value={formValue?.last_name}
                placeholder="Last Name "
                onChange={(e) => onChange(e, "last_name")}
              />
              {errors?.last_name && (
                <Form.ErrorMessage show={errors?.last_name}>
                  {errors?.last_name}
                </Form.ErrorMessage>
              )}
            </Form.Group>
            <Form.Group className="col-md-12">
              <Input
                type="email"
                value={formValue?.email}
                placeholder="Email "
                onChange={(e) => onChange(e, "email")}
              />
              {errors?.email && (
                <Form.ErrorMessage show={errors?.email}>
                  {errors?.email}
                </Form.ErrorMessage>
              )}
            </Form.Group>

            {/* Details */}
            <Form.Group>
              <Input
                value={formValue?.description}
                placeholder="Any other information that you would like to share? "
                as="textarea"
                rows={3}
                onChange={(e) => onChange(e, "description")}
              />

              {errors?.description && (
                <Form.ErrorMessage show={errors?.description}>
                  {errors?.description}
                </Form.ErrorMessage>
              )}
            </Form.Group>
            {/* subscribe */}
            {/* <Checkbox> Subscribe to our Newsletter</Checkbox> */}
            {/* <br /> */}
            <Button
              className="default-button w-100"
              onClick={() => onSubmit()}
              disabled={loading}
            >
              {loading ? <Loader /> : "Submit"}
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Inquire;
